module.exports = __webpack_public_path__ + "img/photo-lpc2.2f10b97f.jpg";